export function handleKendoGrid(selector) {
	kendoGrid(selector);
}

function kendoGrid(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[kendo-grid]');
	} else {
		var $cont = $(selector + ' [kendo-grid]');
	}

	$cont.each(function (idx) {
		let $el = $(this);

		if (! $el.is('table')) {
			return;
		}

		console.log('kendo init');

		$el.kendoGrid({
			scrollable: true,
			height: "99%",
			sortable: true,
			filterable: true,
			resizable: true,
			reorderable: true,
			selectable: "row",
			navigatable: true,
			change: function(e) {
				if ($el.data('change') !== 'undefined') {
					let callbackName = $el.data('change');
					if (typeof window[callbackName] == 'function') {
						window[callbackName](e)
					}
				}
			}
		});

		var grid = $el.data("kendoGrid");

		grid.bind("columnResize", saveGridState);
		grid.bind("columnReorder", saveGridState);
		grid.bind("sort", saveGridState);

		var options = localStorage[$el.attr('id')];
		if (options) {
			// grid.setOptions(JSON.parse(options));
		}
	});
}

export function saveGridState(e) {
	e.preventDefault();

	var gridId = e.sender.element.attr('id')

	setTimeout(function() {
		var options = $('#' + gridId).data('kendoGrid').getOptions();

    var key = gridId + '-version-' + draftOrderColumnsVersion;

		localStorage[key] = kendo.stringify(options.columns);
	}, 600);
}

window.saveGridState = saveGridState

export function kendoGridMoveToNextRow(gridId) {
	let $grid = $('#' + gridId);
	let grid = $grid.data("kendoGrid");
	let $selectedTr = $grid.find('tr.k-state-selected');
  let $nextTr = $selectedTr.next();
	if ($nextTr.length === 1) {
		let $row = $grid.find("tr[data-uid='" + $nextTr.data('uid') + "']");
		changeRow($grid, $row)
	}
}
window.kendoGridMoveToNextRow = kendoGridMoveToNextRow

export function kendoGridMoveToPrevRow(gridId) {
	let $grid = $('#' + gridId);
	let grid = $grid.data("kendoGrid");
	let $selectedTr = $grid.find('tr.k-state-selected');
  let $prevTr = $selectedTr.prev();
  if ($prevTr.length === 1) {
    let $row = $grid.find("tr[data-uid='" + $prevTr.data('uid') + "']");
    changeRow($grid, $row)
  }
}
window.kendoGridMoveToPrevRow = kendoGridMoveToPrevRow

function changeRow($grid, $row) {
	let grid = $grid.data("kendoGrid");

	grid.clearSelection();
	grid.select($row);
	grid.trigger("change");
	grid.table.focus();

	var scrollContentOffset = grid.element.find("tbody").offset().top;
	var selectContentOffset = grid.select().offset().top;
	var distance = selectContentOffset - scrollContentOffset - ($grid.find(".k-grid-content").height() / 2);

	$grid.find(".k-grid-content").animate({
		scrollTop: distance
	}, 0);
}
